export default __webpack_public_path__ + "static/media/submit.e61a0730.png";